export default __webpack_public_path__ + "static/media/icon-house.3487e461.svg";